export default "__VITE_ASSET__22d45789__"